export const unit_hash = {
    1: '单位：元',
    1000: '单位：千元',
    10000: '单位：万元',
    1000000: '单位：百万元',
}